import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CUnderLine extends BasicCPCLArg<CUnderLine> {
  private underline: boolean;

  constructor(options?: {
    /**
     * 是否下划线
     */
    underline?: boolean
  }) {
    super();
    this.underline = options?.underline ?? false;
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendText(this.underline ? "ON" : "OFF")
      .clause();
  }

  header(): string {
    return 'UNDERLINE';
  }
}



